import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const APP_NAME = "Dev Team Portal";

const pathToTitle = {
  "/login": "Sign In",
  "/change-password": "Change Password",
  "/main/dashboard": "Dashboard",
  "/main/week-schedule": "Week Schedule",
  "/main/assigned-to-you": "Assigned to You",
  "/main/documentation": "Documentation",
  "/main/dev-rules": "Dev Rules",
  "/dev-rules": "Dev Rules",
  "/notifications": "Notifications",
  "/task-board": "Task Board",
  "/task-board/projects": "Projects",
  "/task-board/squads": "Squads",
  "/task-board/sprints": "Sprints",
  "/profile": "Profile",
  "/management/employees": "Employees",
  "/management/requests": "Requests",
  "/management/hr-form": "HR Form",
  "/management/monthly-report": "Monthly Report",
  "/management/system-status": "System Status",
  "/communication/tickets": "Tickets",
  "/communication/chat": "Chat",
  "/communication/meeting-notes": "Notes",
  "/communication/expenses": "Expenses",
  "/management/attendance": "Attendance",
  "/management/attendance/admin": "All Attendance",
  "/unauthorized": "Unauthorized",
  "/logout": "Logging out",
};

/**
 * Sets document.title based on current route.
 * Renders nothing. Use once inside BrowserRouter (e.g. in App).
 */
function PageTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    let pageTitle = pathToTitle[pathname];

    if (
      !pageTitle &&
      (pathname.startsWith("/communication/tickets/") ||
        pathname.startsWith("/tickets/"))
    ) {
      pageTitle = "Ticket";
    }
    if (
      !pageTitle &&
      (pathname.startsWith("/communication/meeting-notes/") ||
        pathname.startsWith("/meeting-notes/"))
    ) {
      pageTitle = "Note";
    }
    if (!pageTitle) {
      const detail = pathname.match(/^\/task-board\/(projects|squads|sprints)\/[^/]+$/);
      if (detail) pageTitle = { projects: "Project", squads: "Squad", sprints: "Sprint" }[detail[1]];
    }
    if (!pageTitle && pathname !== "/") {
      pageTitle = "Page Not Found";
    }

    document.title = pageTitle ? `${pageTitle} – ${APP_NAME}` : APP_NAME;
  }, [pathname]);

  return null;
}

export default PageTitle;
